import React from "react";
import PropTypes from "prop-types";
// import {Link} from 'react-router-dom'
// eslint-disable-next-line
import classNames from "classnames";
import Button from "../button";
import { v4 as uuidv4 } from "uuid";

function getButton(
  textButton,
  isActive,
  isDisabled,
  isMore,
  isOutlineButton,
  themeButton,
  onClick
) {
  let className = "";
  if (isActive) {
    className += "white-primary ";
  }

  if (!themeButton || !themeButton.length) {
    themeButton = "default";
  }

  return (
    <li className={className} key={`pagination-${uuidv4()}`}>
      <Button
        size="s"
        disabled={isDisabled}
        onClick={onClick}
        outline={isOutlineButton}
        theme={themeButton}
      >
        {textButton}
      </Button>
    </li>
  );
}

function isShowAndText(pages, page, i) {
  // Is minimum?
  if (pages < 11) {
    return [true, false];
  }

  if (page < 5) {
    if (i < 7) {
      return [true, false];
    }

    if (i === pages - 3) {
      return [true, true];
    }

    if (i >= pages - 2) {
      return [true, false];
    }
  } else if (page >= pages - 5) {
    if (i >= pages - 7) {
      return [true, false];
    }

    if (i === 2) {
      return [true, true];
    }

    if (i < 2) {
      return [true, false];
    }
  } else {
    if (i < 2) {
      return [true, false];
    }

    if (i >= page - 2 && i <= page + 2) {
      return [true, false];
    }
    if (i === page - 3 || i === page + 3) {
      return [true, true];
    }

    if (i + 2 > pages) {
      return [true, false];
    }
  }

  return [false, false];
}

class Pagination extends React.Component {
  getList = (page, pages) => {
    if (pages < 1) {
      return [];
    }

    const listLinks = [];

    for (let i = 0; i <= pages; i++) {
      let [isNeedShow, isMoreButton] = isShowAndText(pages, page, i);
      if (isNeedShow) {
        listLinks.push(
          getButton(
            isMoreButton ? ".." : i + 1,
            page === i,
            page === i || isMoreButton,
            isMoreButton,
            page !== i,
            null,
            page !== i && !isMoreButton ? () => this.props.onClick(i) : null
          )
        );
      }
    }

    return listLinks;
  };

  render() {
    const { page, pages } = this.props;

    const paginationClasses = classNames(
      "nav",
      "pagination",
      {},
      this.props.className
    );

    const responseClasses = classNames(
      "pagination-container",
      this.props.responseClassName
    );

    if (pages > 0) {
      return (
        <div className={responseClasses}>
          <ul className={paginationClasses}>
            {this.getList(parseInt(page || 0, 10) || 0, pages)}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  }
}

Pagination.propTypes = {
  onClick: PropTypes.func.isRequired,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  pages: PropTypes.number.isRequired,
  responseClassName: PropTypes.string
};

export default Pagination;
